import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* listCustomer(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CUSTOMERS.LIST_CUSTOMER, action.payload, true);
}

export function* searchCustomer(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.SEARCH_CUSTOMER, action.payload, true);
}

export function* addUpdateCustomer(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.ADD_UPDATE_CUSTOMER, action.payload, true);
}

export function* deleteCustomer(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.DELETE_CUSTOMER, action.payload, true);
}

export function* customerDetails(action: any): any {
    const customerId = action.payload?.customerId;
    yield call(sagaFunction, action, CallApi.GET, `${APIS.CUSTOMERS.CUSTOMER_DETAILS}${customerId}`, {}, true);
}

export function* importCustomers(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.IMPORT_CUSTOMERS, action.payload, true);
}

export function* listCustomerGroups(action: any): any {
    try {
        const resp = yield call(CallApi.GET, APIS.CUSTOMERS.LIST_CUSTOMER_GROUPS, action.payload, true);
        
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            // Extract customer groups data from response
            let customerGroups = resp.data?.data?.items || resp.data?.data || resp.data;
            
            yield put({
                type: ACTIONS.CUSTOMERS.LIST_CUSTOMER_GROUPS,
                payload: customerGroups,
            });
            
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.errorMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteCustomerGroup(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.DELETE_CUSTOMER_GROUP, action.payload, true);
}

export function* addUpdateCustomerGroup(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP, action.payload, true);
}

export function* customerGroupRuleMaster(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CUSTOMERS.CUSTOMER_GROUP_RULE_MASTER, action.payload, true);
}

export function* searchCustomerGroups(action: any): any {
    const data = action.payload || {};
    const customerGroupId = data.customerGroupId || "";
    yield call(sagaFunction, action, CallApi.GET, `${APIS.CUSTOMERS.SEARCH_CUSTOMER_GROUPS}${customerGroupId}`, {}, true);
}

export function* addUpdateCustomerGroupCustom(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP_CUSTOM, action.payload, true);
}

export function* getCustomerPromotions(action: any): any {
    const data = action.payload || {};
    const customerId = data.customerId || "";
    yield call(sagaFunction, action, CallApi.GET, `${APIS.CUSTOMERS.GET_CUSTOMER_PROMOTIONS}${customerId}`, {}, true);
}